import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo, faLock } from '@fortawesome/free-solid-svg-icons';

export default function ProjectVisibilityStatus({ project }) {
  if (project?.visibility?.isPublic !== false
      || project?.visibility?.reason !== 'no_published_content') {
    return null;
  }

  const popoverId = `private-project-${project?.id || 'status'}`;
  const visibilityExplanation = (
    <Popover id={popoverId} className="projects-list-visibility-popover">
      <Popover.Header as="h3">Why this project is private</Popover.Header>
      <Popover.Body>
        Only this organization&apos;s admins can view it. Publish at least one guide or BOM to make the project public.
      </Popover.Body>
    </Popover>
  );

  return (
    <OverlayTrigger trigger="click" placement="bottom" rootClose overlay={visibilityExplanation}>
      <button
        type="button"
        className="projects-list-status projects-list-status-private"
        aria-label="Private until published. Show details"
      >
        <FontAwesomeIcon icon={faLock} className="projects-list-status-lock" aria-hidden="true" />
        <span>Private until published</span>
        <FontAwesomeIcon icon={faCircleInfo} className="projects-list-status-info" aria-hidden="true" />
      </button>
    </OverlayTrigger>
  );
}
